var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 3,
    fill: "#CA0018"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 8,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 8H15.9309V16.9056H8.00002V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5197 8C14.3463 9.21559 14.151 10.4075 13.9552 11.5988C12.6979 11.6131 11.4143 11.666 10.2014 11.5683C10.4306 10.4029 10.5949 9.16716 10.8224 8H9.46764C8.98271 10.9731 8.5415 13.9936 8.00002 16.9056H9.38293C9.59991 15.4117 9.80276 13.9027 10.0885 12.4833C11.2677 12.4519 12.6809 12.3972 13.8142 12.5139C13.5805 13.9896 13.2981 15.4127 13.0802 16.9056H14.4633C14.9076 13.8886 15.3758 10.8974 15.9309 8H14.5197Z",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipercard);
export default __webpack_public_path__ + "static/media/hipercard.b3d49682571ee44d7c930e3a6f7a6599.svg";
export { ForwardRef as ReactComponent };